import { type ChartConfig } from "@/components/ui/chart"

/**
 * the Object key is for the data key in the testData.ts file
 * the label is for the legend
 * the color is for the line and the area
 * 
 * It's important to name the components that handle the coloring with the same name as the key in the config object.
 * 
 * Example:
 * 
 * `<linearGradient id="fillRevenue" x1="0" y1="0" x2="0" y2="1">`
 * when the key is "revenue"
 * 
 */
export const chartConfig = {
  completed_project_fees: {
    label: "Completed Project Fees",
    color: "hsl(var(--chart-1))",
  },
  new_project_fees: {
    label: "New Project Fees",
    color: "hsl(var(--chart-2))",
  },
} satisfies ChartConfig